var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrescoLogoWhiteSecondaryStacked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 435 152",
    style: {
      enableBackground: "new 0 0 435 152"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M200.7,50h33.5v-2.5h-11.5l11.1-5.7l-1.1-2.2l-12.2,6.3L228,35l-2.1-1.4l-7.1,10.4V30h-2.5v13.9l-7.1-10.4 L207,35l7.4,10.8l-12.1-6.3l-1.2,2.2l11.1,5.7h-11.5V50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M217.5,58.1c-16.7,0-32.8,4.4-45.3,12.5l-0.5,0.3l1.4,2.1l0.5-0.3c12.1-7.8,27.7-12.1,43.9-12.1 c16.1,0,31.7,4.3,43.8,12l0.5,0.3l1.4-2.1l-0.5-0.3C250.2,62.5,234.1,58.1,217.5,58.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M217.5,0C190.2,0,168,22.2,168,49.5c0,5,0.8,10,2.2,14.8l0.2,0.7l0.7-0.4c0.4-0.2,0.8-0.4,1.1-0.6l0.5-0.2 l-0.1-0.5c-1.4-4.5-2.1-9.1-2.1-13.8c0-25.9,21.1-47,47-47c25.9,0,47,21.1,47,47c0,4.7-0.7,9.3-2.1,13.8l-0.2,0.5l0.5,0.2 c0.4,0.2,0.8,0.4,1.1,0.6l0.7,0.4l0.2-0.7c1.5-4.8,2.2-9.7,2.2-14.8C267,22.2,244.8,0,217.5,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M253.1,59.8l0.6,0.2l1.2,0.5l0.6,0.3l0.2-0.7c1.1-3.7,1.6-7.5,1.6-11.3c0-21.9-17.9-39.8-39.8-39.8 c-21.9,0-39.8,17.9-39.8,39.8c0,3.8,0.6,7.6,1.6,11.3l0.2,0.7l0.7-0.2c0.4-0.2,0.8-0.3,1.2-0.5l0.6-0.2l-0.2-0.6 c-1-3.4-1.5-6.9-1.5-10.5c0-20.5,16.7-37.2,37.2-37.2s37.2,16.7,37.2,37.2c0,3.6-0.5,7.1-1.5,10.5L253.1,59.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M243.6,56.5l2.4,0.7l0.2-0.6c0.7-2.6,1.1-5.2,1.1-7.9c0-16.4-13.4-29.8-29.8-29.8s-29.8,13.4-29.8,29.8 c0,2.8,0.4,5.5,1.1,8.1l0.2,0.6l2.4-0.8l-0.2-0.6c-0.7-2.4-1-4.9-1-7.4c0-15,12.2-27.3,27.3-27.3s27.3,12.2,27.3,27.3 c0,2.4-0.3,4.9-1,7.2L243.6,56.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.4,139.6c-9,0-14.8-6.9-14.8-15.7c0-10,6.7-15.9,14.7-15.9c5.3,0,9.7,2.9,12.7,6.3l9.4-8.1 c-6-7.3-14.4-10.6-22.1-10.6C10.2,95.6,0,108.2,0,123.9c0,18.2,12.6,28,28.4,28c9.7,0,17.4-4.6,22.1-10.4l-9.4-8.1 C37.9,137.2,33.5,139.6,28.4,139.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M122,115.3c0-11-6-18.9-19.6-18.9H81v54.9h12.6v-17.7h4.7l11.3,17.7h15.2l-13.1-19.5 C118.5,129,122,123.3,122,115.3L122,115.3z M100.1,122.3h-6.5v-14.5h6.7c5.8,0,8.3,3.1,8.3,7.3 C108.7,119.6,105.7,122.3,100.1,122.3L100.1,122.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M167.7,129.6H186v-11.1h-18.3v-10.5h23.2V96.4h-35.8v54.9h37.4v-11.5h-24.8V129.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M247,117.7c-6-2.3-8-3.7-7.9-6.3c0-2.6,1.9-4.2,5.1-4.2c3.1,0,6.5,1.5,11.2,5.2l7.3-9.4 c-5.2-4.5-11.8-7.3-19-7.1c-10.2,0.2-18,7-18,16.2c0,10.8,8.4,14.8,16.7,17.6c6.2,2.1,8.1,3.4,8.1,6.4c0,2.5-1.9,4.6-6.2,4.6 c-3.8,0-8.8-1.9-13-6.5l-7.6,9.2c5.9,6,13.1,8.7,20.2,8.7c9.1,0,20.2-4.6,20.2-17.5C264.1,123.8,256.7,121.4,247,117.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M323.1,139.6c-9,0-14.8-6.9-14.8-15.7c0-10,6.7-15.9,14.7-15.9c5.3,0,9.7,2.9,12.7,6.3l9.4-8.1 c-6-7.3-14.4-10.6-22.1-10.6c-18.1,0-28.3,12.6-28.3,28.3c0,18.2,12.6,28,28.4,28c9.7,0,17.4-4.6,22.1-10.4l-9.4-8.1 C332.6,137.2,328.2,139.6,323.1,139.6L323.1,139.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M398.1,95.6c-16.7,0-28.3,11.7-28.3,28.2c0,16.5,11.6,28.1,28.3,28.1c16.4,0,28.2-11.4,28.2-28.1 C426.3,107,414.5,95.6,398.1,95.6z M398.1,140c-8.7,0-14.8-7.2-14.8-16.2s6.1-16.2,14.8-16.2c8.5,0,14.7,7,14.7,16.2 S406.6,140,398.1,140z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M422.1,97h1.8v5.4h1.5V97h1.8v-1.3h-5.1V97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M433.5,95.6l-1.9,3.7l-1.9-3.7h-1.5v6.7h1.4v-4l1.5,2.7h1l1.5-2.7v4h1.5v-6.7H433.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrescoLogoWhiteSecondaryStacked);
export default __webpack_public_path__ + "static/media/CrescoLogo_White_Secondary-stacked.27fddc5d59a1241e5fe8030ae48562ed.svg";
export { ForwardRef as ReactComponent };